import { useSelector } from 'react-redux';

import { SYSTEMS } from '../../constants/systems';
import TurnOffMessageBox from '../commonComponentsMC/controllers/TurnOffMessageBox';
import { selectLocations } from '../store/slices/locationsSlice';
import { selectUserInfo } from '../store/slices/userSlice';
import {
  HeaderButton,
  HeaderButtonHole,
  HeaderButtonOuter,
  HeaderButtonTop,
  HeaderHat,
  HeaderTitle,
  HoverBox,
  SectionHeader,
  SectionHeaderWrapper,
} from './frameStyles';
import { hatImage, titleSize } from './machineCardFacts';

/**
 * The desktop card's header: the device title (hovering shows its location,
 * or who froze it), the sibling system's hat on TGS/TES, the ate hat, and
 * the close button while the card is expanded.
 */
const MachineHeader = ({ system, location, device, title, onClose }) => {
  const { sibling } = SYSTEMS[system];
  const { isOff, freezeBy, openMachineController } = device;
  const locationName = useSelector(selectLocations)[system][location]?.locationName;
  const { allUsers } = useSelector(selectUserInfo);
  const frozenBy = allUsers.find((user) => user.user_id === freezeBy);
  const size = titleSize(title.length);
  const hasSibling = Boolean(sibling);

  return (
    <SectionHeader hasSibling={hasSibling}>
      <SectionHeaderWrapper right sizeStep={size} hasSibling={hasSibling} isExpanded>
        <HeaderHat first sizeStep={size} hasSibling={hasSibling} imgSrc={hatImage(title, device)}>
          <HoverBox>
            <TurnOffMessageBox
              locationName={isOff ? locationName : ''}
              switchName={isOff ? title : 'location'}
              message={
                isOff
                  ? `maintenance in progress by: ${frozenBy?.firstname} ${frozenBy?.lastname}`
                  : locationName
              }
              isSwitchDisabled={isOff}
            />
          </HoverBox>
          <HeaderTitle isSwitch>{title}</HeaderTitle>
        </HeaderHat>

        {sibling && (
          <HeaderHat
            second
            hasSibling
            imgSrc={
              isOff || !device[sibling.activeField]
                ? '/images/MC-machine-header2.svg'
                : '/images/MC-machine-header2-normal.svg'
            }
          >
            <HeaderTitle>{sibling.label}</HeaderTitle>
          </HeaderHat>
        )}

        <HeaderHat second hasSibling={hasSibling} imgSrc='/images/MC-machine-header2.svg'>
          <HeaderTitle>ate</HeaderTitle>
        </HeaderHat>
      </SectionHeaderWrapper>

      <SectionHeaderWrapper isExpanded={openMachineController}>
        <HeaderHat third imgSrc='/images/MC-machine-header3.svg'>
          <HeaderButton onClick={onClose}>
            <HeaderButtonOuter>
              <HeaderButtonHole>
                <HeaderButtonTop>close</HeaderButtonTop>
              </HeaderButtonHole>
            </HeaderButtonOuter>
          </HeaderButton>
        </HeaderHat>
      </SectionHeaderWrapper>
    </SectionHeader>
  );
};

export default MachineHeader;
